<template>
  <div class="create-user-popup">
    <div class="form create-user-popup__content">
      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">User name</label>
          <input
            type="text"
            :class="{'form__input': true, 'is-error': errors.has('name')}"
            v-model="userName"
            v-validate="'required'"
            v-input-trim
            name="name"
          >

          <span class="form__error" v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
      </div>

      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">User email</label>
          <input
            type="text"
            :class="{'form__input': true, 'is-error': errors.has('email')}"
            v-model="userEmail"
            v-validate="'required'"
            name="email"
            v-input-trim
          >

          <span class="form__error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          <span class="form__error" v-if="errorMsg">{{ errorMsg }}</span>
        </div>
      </div>

      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">User password</label>
          <input
            type="text"
            class="form__input"
            :value="userPassword"
            disabled
          >

          <span class="form__error">Please copy and save this password!</span>
        </div>
      </div>

      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">Arena type</label>
          <select class="form__select"
                  v-model="arenaType">
            <option value="premium_only_reports">Premium only reports</option>
            <option value="premium">Premium</option>
          </select>
        </div>
      </div>

      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">CRM Account Name</label>
          <input
            type="text"
            :class="{'form__input': true, 'is-error': errors.has('crm')}"
            v-model="crm"
            v-validate="'required'"
            name="crm"
            v-input-trim
          >

          <span class="form__error" v-show="errors.has('crm')">{{ errors.first('crm') }}</span>
        </div>
      </div>

      <div class="form__row">
        <button class="ark-btn ark-btn--default" @click="toggleCreateForm(false)">
          Cancel
        </button>

        <button class="ark-btn ark-btn--danger create-user-popup__create-btn" @click="createUser">
          <Loader v-if="isUserCreationLoading"></Loader>
          <span v-else>Create</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'

  export default {
    name: 'UsersCreateForm',
    components: {Loader},
    props: ['chosenCRM', 'toggleCreateForm', 'getUsers', 'getAllCRMs'],
    data () {
      return {
        userName: '',
        userPassword: '',
        userEmail: '',
        arenaType: 'premium_only_reports',
        crm: '',
        isUserCreationLoading: false,
        errorMsg: ''
      }
    },
    created: function () {
      this.crm = this.chosenCRM
      this.userPassword = Math.random().toString(36).slice(-6)
    },
    methods: {
      createUser: function () {
        this.isUserCreationLoading = true
        this.errorMsg = ''

        // checking user email if it's already exist

        this.$http.get(`${config.apiUrl}/portal-user/check?email=${this.userEmail}`)
          .then((res) => {
            // if email isn't exist, then create user
            if (!res.body) {
              this.$http.post(`${config.apiUrl}/portal-user/create`, {
                'Name': this.userName,
                'Email': this.userEmail,
                'Password': this.userPassword,
                'ArenaType': this.arenaType,
                'CRMContractName': this.crm
              }).then(() => {
                this.isUserCreationLoading = false
                this.getAllCRMs(this.crm)
                this.toggleCreateForm(false)
              }, error => {
                this.isUserCreationLoading = false
                console.log(error)
              })
            } else {
              this.errorMsg = 'This email is already exist.'
              this.isUserCreationLoading = false
            }
          })
      }
    }
  }
</script>

<style scoped src="./UsersCreateFormPopup.scss" lang="scss"></style>
